/**
 * Quién puede gestionar el catálogo de usuarios (lista, altas, edición completa).
 * Alineado con BuscadorAccesos (Admin + Configuraciones) y roles habituales en JWT.
 */
export function canManageSistemaUsers(roles: string[] | undefined): boolean {
  return (roles ?? []).some((r) => {
    const x = String(r).trim().toLowerCase();
    return x === 'superadmin' || x === 'admin';
  });
}

/** Roles persistidos en login; evita flash de permisos antes de rehidratar `user` en AuthContext. */
export function getRolesFromSessionStorage(): string[] {
  if (typeof window === 'undefined') return [];
  try {
    const raw = localStorage.getItem('roles');
    return raw ? (JSON.parse(raw) as string[]) : [];
  } catch {
    return [];
  }
}

export function effectiveUserRoles(rolesFromContext: string[] | undefined): string[] {
  if (rolesFromContext && rolesFromContext.length > 0) return rolesFromContext;
  return getRolesFromSessionStorage();
}

export function getUsernameFromSessionStorage(): string {
  if (typeof window === 'undefined') return '';
  const u =
    localStorage.getItem('username') ||
    localStorage.getItem('userName') ||
    localStorage.getItem('user') ||
    '';
  return u.trim();
}

export function effectiveUsername(usernameFromContext: string | undefined): string {
  const u = usernameFromContext?.trim();
  if (u) return u;
  return getUsernameFromSessionStorage();
}
